import { useQuery } from '@tanstack/react-query';
import { http } from 'services/http';
import { TRIP_TASKS_GET_MANY } from 'api/query-keys.ts';
import type { TTripTaskRes } from 'api/swagger';

interface IParams {
  tripId: number;
}

export const useGetTripTasks = (params: IParams) => {
  const { tripId } = params;
  return useQuery<TTripTaskRes[]>({
    queryKey: [TRIP_TASKS_GET_MANY, tripId],
    queryFn: async () => {
      const { data } = await http.get<TTripTaskRes[]>(`/v1/trips/${tripId}/trip-tasks`);
      return data;
    },
    retry: false,
    refetchOnWindowFocus: false,
    staleTime: 0,
    cacheTime: 0,
  });
};
